import router from "../../router";
import services from "../../services/services";

const state = {
  token: "",
  refreshToken: "",
};

const mutations = {
  SET_TOKEN: (state, payload) => {
    state.token = payload;
    localStorage.setItem("access-token", payload);
  },
  SET_REFRESH_TOKEN: (state, payload) => {
    state.refreshToken = payload;
    localStorage.setItem("refresh-token", payload);
  },
  PARSE_TOKEN: (state, payload) => {
    const parsedToken = JSON.parse(atob(payload.split(".")[1]));
    state.id = parsedToken.id;
  },
};

const actions = {
  authUser: ({ commit }, payload) => {
    return services.authUser(payload).then((response) => {
      if (response.status === 200) {
        commit("SET_TOKEN", response.data.token);
        commit("SET_REFRESH_TOKEN", response.data.refresh_token);
        commit("PARSE_TOKEN", response.data.token);
      }
      return response;
    });
  },
  updateTokensFromRefresh: ({commit}, payload) => {
    commit("SET_TOKEN", payload.data.token);
    commit("SET_REFRESH_TOKEN", payload.data.refresh_token);
    commit("PARSE_TOKEN", payload.data.token);
  },
  logOut: ({ commit }) => {
    localStorage.removeItem("access-token");
    commit("SET_TOKEN", "");
    commit("SET_REFRESH_TOKEN", "");
    router.push("/login");
  },
};

const getters = {
  getToken: (state) => state.token,
  getRefreshToken: (state) => {
    return state.refreshToken},
  getId: (state) => state.id,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
